export default "/_next/static/fonts/4f0229a4bc748a67ce2cc5051d07bdb1.woff2";